// Same rule as User#first_name on the backend: skip titles like "Dra." so the greeting says "Ana", not "Dra.".
const HONORIFICS = ["dr", "dra", "dr(a)", "doutor", "doutora", "prof", "profa", "professor", "professora", "sr", "sra"];

export function firstName(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  const word = parts.find((w) => !HONORIFICS.includes(w.toLowerCase().replace(/\./g, "").replace(/\(a\)$/, ""))) || parts[0] || "";
  if (!word) return "";
  // Names typed in CAPS ("MAURICIO") read as shouting in a greeting: normalize those only.
  const rest = word.length > 1 && word === word.toUpperCase() ? word.slice(1).toLowerCase() : word.slice(1);
  return word.charAt(0).toUpperCase() + rest;
}
